import { MenuItem } from '@bn/layout';

import { AppRoutes } from '../core/enums';

export const mobileMenuConfig: MenuItem[] = [
  { name: 'Customers', icon: ['fad', 'user-group'], route: AppRoutes.Overview },
  { name: 'Pricing', icon: ['fad', 'circle-dollar'], route: AppRoutes.Pricing },
  { name: 'Contract', icon: ['fad', 'file-lines'], route: AppRoutes.Contract },
  { name: 'Menu', icon: 'bars', action: 'toggle-menu' },
];
